type Props = {
  extraParentClass?: string
  contents: [
    React.ReactNode,
    React.ReactNode,
    React.ReactNode,
    React.ReactNode,
    React.ReactNode,
    React.ReactNode,
  ]
}

const MediaLibraryColumns = ({ extraParentClass, contents }: Props) => {
  return (
    <div
      className={`grid grid-cols-6 lg:grid-cols-12 items-center gap-4 ${extraParentClass}`}
    >
      <div className='lg:col-span-2 col-span-2 p-4'>{contents[0]}</div>
      <div className='lg:col-span-3 col-span-2'>{contents[1]}</div>
      <div className='col-span-2 hidden lg:block'>{contents[2]}</div>
      <div className='col-span-1 hidden lg:block'>{contents[3]}</div>
      <div className='col-span-2 hidden lg:block'>{contents[4]}</div>
      <div className='lg:col-span-2 col-span-2 justify-self-end px-8'>
        {contents[5]}
      </div>
    </div>
  )
}

export default MediaLibraryColumns
